import { Row, Col, Modal, Form, Input, Select } from "antd";
import React, { useState, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";
import lang from "../../helper/lang";
import { CloseOutlined, CheckOutlined } from "@ant-design/icons";

const { Option } = Select;

const IntegrationForm = ({ show, hide, data, refresh, isUpdate }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);

  // CREATE / UPDATE
  const onSubmit = (values) => {
    setLoading(true);

    const payload = {
      name: values.name,
      code: values.code,
      category: values.category,
      provider: values.provider,
      apiKey: values.apiKey,
      ...(isUpdate && { isEnabled: values.isEnabled }),
    };

    request({
      url: isUpdate
        ? `${apiPath.updateIntegration}/${data._id}`
        : apiPath.createIntegration,
      method: isUpdate ? "PUT" : "POST",
      data: payload,
      onSuccess: (res) => {
        setLoading(false);
        if (res.status) {
          ShowToast(res.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(res.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error.response?.data?.message, Severty.ERROR);
      },
    });
  };

  // PREFILL DATA (EDIT MODE)
  useEffect(() => {
    if (!data) return;

    form.setFieldsValue({
      name: data.name,
      code: data.code,
      category: data.category,
      apiKey: data.apiKey,
      provider: data.provider,
      isEnabled: data.isEnabled,
    });
  }, [data]);

  return (
    <Modal
      width={550}
      open={show}
      title={data ? "Update Integration" : "Add New Integration"}
      okText={data ? "Update" : "Add"}
      cancelText={
        <>
          <CloseOutlined style={{ marginRight: 8 }} />
          {lang("Cancel")}
        </>
      }
      onCancel={hide}
      okButtonProps={{
        form: "integration-form",
        htmlType: "submit",
        loading,
        icon: <CheckOutlined />,
      }}
    >
      <Form
        id="integration-form"
        form={form}
        onFinish={onSubmit}
        layout="vertical"
      >
        <Row gutter={[16, 16]}>
          {/* Integration Name */}
          <Col span={24}>
            <Form.Item
              label="Integration Name"
              name="name"
              rules={[{ required: true, message: "Enter integration name" }]}
            >
              <Input placeholder="e.g. Google Maps" />
            </Form.Item>
          </Col>

          {/* Integration Code */}
          <Col span={24}>
            <Form.Item
              label="Integration Code"
              name="code"
              rules={[{ required: true, message: "Enter unique code" }]}
            >
              <Input placeholder="e.g. GOOGLE_MAPS" disabled={isUpdate} />
            </Form.Item>
          </Col>

          {/* Category */}
          <Col span={24}>
            <Form.Item
              label="Category"
              name="category"
              rules={[{ required: true, message: "Select category" }]}
            >
              <Select placeholder="Select category">
                <Option value="MAPS">Maps</Option>
                <Option value="VIDEO">Video</Option>
                <Option value="NOTIFICATION">Notification</Option>
                <Option value="OTHER">Other</Option>
              </Select>
            </Form.Item>
          </Col>

          {/* Provider */}
          <Col span={24}>
            <Form.Item
              label="Provider"
              name="provider"
              rules={[{ required: true, message: "Enter provider name" }]}
            >
              <Input placeholder="e.g. Google / AWS / Twilio" />
            </Form.Item>
          </Col>

          {/* API Key */}
          <Col span={24}>
            <Form.Item
              label="API Key"
              name="apiKey"
              rules={[
                {
                  required: !isUpdate,
                  message: "API Key is required",
                },
              ]}
            >
              <Input.Password placeholder="Enter API key" />
            </Form.Item>
          </Col>

          {/* Enable / Disable (Edit Only) */}
          {isUpdate && (
            <Col span={24}>
              <Form.Item
                label="Status"
                name="isEnabled"
                rules={[{ required: true }]}
              >
                <Select>
                  <Option value={true}>Enabled</Option>
                  <Option value={false}>Disabled</Option>
                </Select>
              </Form.Item>
            </Col>
          )}
        </Row>
      </Form>
    </Modal>
  );
};

export default IntegrationForm;
